"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTextHeader = void 0;
const react_1 = __importDefault(require("react"));
const ValidationOptimizer_1 = __importDefault(require("../wrappers/ValidationOptimizer"));
const FieldRender_1 = __importDefault(require("../wrappers/FieldRender"));
/**
 * This is a helper function to create the most typical type of Page component, one that supports conditional display,
 * repeatable fields, field level validation, and read only support
 * @param controlProvider The map of controls from which to grab the consumer's implementation
 * @param componentType the form component type name that we are building
 */
const generateTextHeader = (controlProvider) => {
    const TextHeader = (props) => {
        const Control = controlProvider['textheader'];
        const { controlDefinition, controlPath, values, value, displayMap, hidden } = props;
        if (Control) {
            return (react_1.default.createElement(ValidationOptimizer_1.default, { key: controlPath, controlDefinition: controlDefinition, displayMap: displayMap, render: validationFn => {
                    return (react_1.default.createElement(FieldRender_1.default, { controlPath: controlPath, controlDefinition: controlDefinition, validationFn: validationFn, value: value, values: values, defaultDateTimeFormat: props.defaultDateTimeFormat, render: props => {
                            var _a;
                            return ((_a = props.displayOptions) === null || _a === void 0 ? void 0 : _a.isVisible) !== false && !hidden ? (react_1.default.createElement(Control, { values: values, value: value, functionDefinitions: props.functionDefinitions, controlDefinition: controlDefinition, controlPath: controlPath })) : react_1.default.createElement(react_1.default.Fragment, null);
                        } }));
                } }));
        }
        return null;
    };
    return TextHeader;
};
exports.generateTextHeader = generateTextHeader;
